const aircraftHistory = [
    {
        year: 2023,
        name: "MX-9",
        subteam: "Advanced",
        config: "BWB",
        wingspan: 9.95,
        emptyWeight: 17,
        staticThrust: 11.4,
        toDistance: 226,
        fuselageLength: 4.5, 
        mtow: 33,
        payload: 16,
        cdrSlides: "https://www.dropbox.com/scl/fi/xfqd0nwc5pxis5u9z1elj/2023-2024-M-Fly-Advanced-Class-CDR-Presentation.pptx?rlkey=y1hytb3l2xme6tbisd5sa0dy1&dl=0",
        report: "https://www.dropbox.com/scl/fi/pvofllgs76kx6k9ypvthu/M_Fly_2024_Advanced_Class.pdf?rlkey=n7q1b4vv06bentjz3fs068dui&st=54d9s5wz&dl=0",
        flightVideos: "https://photos.app.goo.gl/XJ8b8WBuvK6QvaYT8",
        compResults: "3 ovr, 2 rep, 3 prs, 2 fl",
        picture: require("../../img/aircraft/mx9_cropped.jpg"),
    },
    {
        year: 2023,
        name: "M-16",
        subteam: "Hi-Lift",
        flightVideos: "https://photos.app.goo.gl/dboyiDvCZtLzrt2p9",
        picture: require("../../img/aircraft/m16.jpg"),
    },
    {
        year: 2022,
        name: "MAT-4",
        subteam: "Autonomous",
        config: "B&W",
        wingspan: 11.25,
        emptyWeight: 30,
        staticThrust: 18,
        toDistance: 265,
        mtow: 44,
        payload: 12,
        flightVideos: "https://photos.app.goo.gl/uGrEpmruME5DNcut5",
        picture: require("../../img/aircraft/mat4.jpg"),
    },
  {
    year: 2018,
    name: "MX-4",
    subteam: "Advanced",
    config: "BWB",
    wingspan: 12,
    fuselageLength: 3.5,
    emptyWeight: null,
    mtow: 44,
    payload: 29,
    staticThrust: 10.5,
    toDistance: null,
    cdrSlides: "https://www.dropbox.com/scl/fi/gpvhbnvq2read1o5033dw/2018-Advanced-Class-CDR-Presentation.pptx?rlkey=vjh3tw0kxjadz3prnvquf6ywb&dl=0",
    report: "https://www.dropbox.com/scl/fi/khuox9jvyjwm74akb52gu/Team219DesignReport.pdf?rlkey=fiyg0yuygznipl9fgkquu4fqe&st=2k52yhwe&dl=0",
    compResults: "10 ovr, 4 rep, 17 prs, 10 fl",
    flightVideos: "https://www.dropbox.com/scl/fi/b2y92i4w8ybnnouf6kue1/mx4_first_flight.mov?rlkey=v7qfuzlhk0x4y0ytt9v1yfme5&dl=0",
    picture: require("../../img/aircraft/mx4.png"),
  },
  {
    year: 2018,
    name: "M-11",
    subteam: "Hi-Lift",
    config: null,
    wingspan: null,
    fuselageLength: null,
    emptyWeight: null,
    mtow: null,
    payload: null,
    staticThrust: null,
    toDistance: null,
    cdrSlides: "https://www.dropbox.com/scl/fi/qhuxcs6jnf0rdd3nq8bc9/CDR-TEMPLATE-2018-2019.pptx?rlkey=e9d8i6uj0o1g8w2blc7hivgdl&dl=0",
    report: null,
    compResults: null,
    flightVideos: "https://www.dropbox.com/scl/fi/idx436p1tfxgnyz71jody/20190216_130721.mp4?rlkey=nxl19i7ckpd70je5wpojtgm5l&dl=0",
    picture: require("../../img/aircraft/m11.png"),
  },
  {
    year: 2016,
    name: "MX-2",
    subteam: "Advanced",
    config: "BWB",
    wingspan: 14.09,
    fuselageLength: 3.61,
    emptyWeight: 15.5,
    mtow: 33.5,
    payload: 18,
    staticThrust: 8,
    toDistance: null,
    cdrSlides:
      "https://www.dropbox.com/scl/fi/njylc3xiz6cypzk0nviht/11-21-Advanced-CDR.pdf?rlkey=bd7smw8eoe2z101nzhv2no4ru&dl=0",
    report: "https://www.dropbox.com/scl/fi/ucyevu6ktl0rmrkuxnzsn/M_Fly_2017_Advanced.pdf?rlkey=hwxw1c9e6u25t285c5mo6x8f6&st=hsujzdiu&dl=0",
    compResults: "3 ovr, 3 rep, 4 prs, 3 fl",
    flightVideos: "https://www.dropbox.com/scl/fi/keedyje2o8zvet0uothbk/Competition-2016-FPV-Video-1.mpg?rlkey=4o4aie1vi821yg5nonlr6r4y3&dl=0",
    picture: require("../../img/aircraft/mx2.png"),
  },
];

export default aircraftHistory;
